import Ad from '@/components/Ad';
import animateScrollTo from 'animated-scroll-to';
import classNames from 'classnames/bind';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import getPlacement from './placements';

const Preview = ({
  entry,
  url,
  pid,
  autoplay = false,
  placement = null,
  app = false,
}) => {
  const [show, setShow] = useState(false);
  const [hover, setHover] = useState(0);
  const [place, setPlace] = useState(null);
  const cover = useRef();
  const iframe = useRef();
  let data = JSON.stringify({ entry: entry });
  data = encodeURIComponent(data);
  const { query } = useRouter();
  const mode = query.mode || 'mobile';

  const cx = classNames.bind(styles);

  const player = useCallback(() => {
    if (typeof window !== 'undefined') {
      if (typeof window.timeouts === 'undefined') window.timeouts = [];

      window.timeouts.forEach((t) => clearTimeout(t));
      window.timeouts.push(setTimeout(() => setHover(true), 1500));
      window.timeouts.push(setTimeout(() => setShow(true), 2000));
      window.timeouts.push(
        setTimeout(() => {
          const contentWindow = iframe?.current?.contentWindow;
          const h =
            contentWindow?.document.body?.scrollHeight -
            contentWindow.innerHeight;
          animateScrollTo(h, { elementToScroll: iframe?.current }).then(
            (has) => {
              if (has) {
                animateScrollTo(0, { elementToScroll: iframe?.current }).then(
                  (hhas) => {
                    if (hhas) {
                      window.timeouts.push(
                        setTimeout(() => setHover(false), 2500),
                      );
                      window.timeouts.push(
                        setTimeout(() => setShow(false), 2500),
                      );
                      window.timeouts.push(player, 2500);
                    }
                  },
                );
              }
            },
          );
        }, 3000),
      );
    }
  }, [iframe, setHover, setShow]);

  const open = () => {
    if (window.timeouts) window.timeouts.forEach((t) => clearTimeout(t));
    setShow(true);
  };

  const close = () => {
    if (window.timeouts) window.timeouts.forEach((t) => clearTimeout(t));

    setShow(false);
  };

  useEffect(() => {
    if (!placement) return;
    let p = getPlacement(placement, null);
    setPlace(p);
  }, [setPlace, placement]);

  return (
    <div className={cx('container', { show, app }, mode)}>
      <div className={styles.preview}>
        <div
          className={cx('screen', show)}
          style={{ backgroundColor: place?.bg ? place?.bg : null }}
        >
          {(placement == 'generic' || !place) && (
            <div className={styles.header} />
          )}
          {place && (
            <div className={styles.headerFrame}>
              <Image
                src={`/placeholders/${place.title}.png`}
                width={375}
                height={place.height}
                alt=""
              />
            </div>
          )}

          <div className={styles.contents}>
            <div className={styles.fake} />

            <div
              className={styles.cover}
              onClick={open}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              <motion.div
                style={{ '--cs__width': '300px', '--cs__height': '250px' }}
                animate={{ scale: hover ? 1.015 : 1, z: 1 }}
                transition={{ stiffness: 50 }}
                ref={cover}
                layout
              >
                <Ad {...entry} url="#" />
              </motion.div>
            </div>

            <div className={styles.fake} />
            <div className={styles.fake} />
          </div>

          <motion.div
            className={styles.article}
            animate={{ y: !show ? '100%' : '0', z: 1 }}
            initial={{ y: '100%' }}
            transition={{ stiffness: 5 }}
          >
            <iframe
              ref={iframe}
              className={styles.iframe}
              src={
                show ? (pid !== 'generate' ? url : `${url}?data=${data}`) : null
              }
            />
          </motion.div>
        </div>

        <div className={styles.close} onClick={close} />
      </div>
    </div>
  );
};

export default Preview;
